/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Order type enumeration
 */
export enum OrderType {

    Market = 'MARKET',

    Limit = 'LIMIT',

    Stop = 'STOP',

    StopLimit = 'STOP_LIMIT',

    Ioc = 'IOC',

    Fok = 'FOK',

    Iceberg = 'ICEBERG'
}
